import React, { useEffect, useState } from 'react';
import styles from './Accordion.module.scss';
import className from 'classnames/bind';
import { useRouter } from 'next/compat/router';
import { CircledChevronDown, CircledChevronUp } from '@/components';
import formatUrlPath from '@/helpers/formatUrlPath';

let cx = className.bind(styles);

export function Accordion({ children, openIcon, closeIcon, id, className, anchorsEnabled = false, expandMultipleItems = false, ...props }) {
	const classNameArray = className?.split(' ') || [];
	const [openItem, setOpenItem] = useState(undefined);
	const pathname = useRouter().asPath.split(/[#]/)[0];

	useEffect(() => {
		if (anchorsEnabled && (openItem || openItem === null)) {
			const url = `${pathname}${openItem?.anchor ? `#${formatUrlPath(openItem.anchor)}` : ''}`;
			window.history.replaceState({ ...window.history.state, as: url }, document.title, url);
		}
	}, [openItem]);

	return (
		<div className={cx(['ns_accordion', 'accordion', ...classNameArray])} {...props}>
			{React.Children.map(children, (child, index) => {
				return React.cloneElement(child, {
					accordionSettings: {
						id: `${id}-${index}`,
						openItem: openItem,
						setOpenItem: setOpenItem,
						openIcon: openIcon || <CircledChevronDown className={cx('accordion-chevron')} />,
						closeIcon: closeIcon || <CircledChevronUp className={cx('accordion-chevron')} />,
						anchorsEnabled: anchorsEnabled,
						expandMultipleItems: expandMultipleItems,
					},
				});
			})}
		</div>
	);
}
